import { query } from "gql-query-builder";
import type { SuperGraphProductListingResponse } from "../interfaces/superGraphQL";
import ENV from "../utils/env";
import { postUri } from "../utils/fetch";

export function getProductListingVersionsAndCertifications(
	id: string,
	abortSignal?: AbortSignal,
): Promise<SuperGraphProductListingResponse> {
	const productListingQuery = query({
		operation: {
			name: "product_listing",
			alias: "product_listing",
		},
		variables: {
			id: { name: "id", value: id, required: true, type: "ObjectIDFilterScalar" },
		},
		fields: [
			{
				product_versions_connection: [
					{
						edges: [
							{
								node: [
									"product_version",
									"product_listing",
									{
										redhat_affinity: ["product_name", "support_future_versions", "versions"],
									},
								],
							},
						],
					},
				],
			},
			{
				functional_info: [
					{
						certifications: [
							"certificationLevel",
							"partnerProductVersion",
							"product",
							"majorVersion",
							"certificationTypeShortName",
						],
					},
				],
			},
		],
	});
	const additionalParams: RequestInit = {
		headers: {
			"apollographql-client-name": "PLS-001-rhc-product-listing",
			"apollographql-client-version": import.meta.env.VITE_SPA_VERSION || "dev",
		},
	};
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	if (!ENV.superGraphQl) {
		throw new Error("SuperGraph URL is not configured for the current environment.");
	}
	return postUri(ENV.superGraphQl!, productListingQuery, additionalParams);
}
